export enum CategoryValues {
  SANITARY = 'sanitary',
  TECHNICAL = 'technical',
  STAFF = 'staff',
  ENVIRONMENTAL = 'environmental',
}

export enum CriticalityValues {
  CRITICAL = 'critical',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}
